import request from '@/utils/http/sp-request'
const BASE_URL = "v1/tvh/cockpit";

//PDM板材颜色销售榜
export function charts(param) {
    return request({
        url: `${BASE_URL}/charts`,
        method: 'post',
        data: param
    })
}


//延时订单数量
export function delayContract(param) {
    return request({
        url: `${BASE_URL}/getDelayContractCount`,
        method: 'post',
        data: param
    })
}
